import React from 'react';
import { useDashboardModel } from './model';
import { DashboardView } from './view';

export const DashboardWidget: React.FC = () => {
  const { loading, data, refresh } = useDashboardModel();

  return <DashboardView loading={loading} data={data} onRefresh={refresh} />;
};
